import { useGrowthBook } from 'fitify-ui-onboarding/src/utils/growthbook/generated'
import { useEffect } from 'react'

import { useFunnel } from 'hooks/useFunnel'

export const useGrowthBookAttributes = () => {
  const funnel = useFunnel()
  const { ready, updateAttributes } = useGrowthBook()

  useEffect(() => {
    if (ready && funnel) {
      void updateAttributes({ funnel_id: funnel })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funnel, ready])
}
